<template>
  <div class="modal">
    <ModalViewerMotion
      :motion-key="motionId"
      @enter-complete="handleEnterComplete"
    >
      <ModalViewerTemplate
        :title="title"
        @update-header-height="handleUpdateHeaderHeight"
      >
        <template #header>
          <slot name="header" />
        </template>
        <template #content>
          <slot name="content" />
        </template>
      </ModalViewerTemplate>
    </ModalViewerMotion>
  </div>
</template>

<script lang="ts" setup>
import { isTouchDevice } from '~/lib/utils/device';

interface Props {
  title: string;
  id: string | null;
}

const props = defineProps({
  title: null,
  id: null
});

const emit = defineEmits(["updateHeaderHeight", "closed"]);

const handleUpdateHeaderHeight = (height: number) => {
  emit('updateHeaderHeight', height);
};

// const overlayScreenScroll = useOverlayScreenScroll('modal-opened');

const motionId = computed(() => {
  return props.id || 'empty';
});

const { start: delayClose, stop: stopClosing } = useTimeout(500, {
  controls: true,
  callback: () => {
    close();
  },
  immediate: false,
});

// stopClosing();

const breakpoints = useEvaBreakpoints();

const isAboveL = breakpoints.greaterOrEqual('l');

const close = () => {
  emit('closed');
};

watch(
  () => props.id,
  (id) => {
    if (id) {
      stopClosing();
    } else {
      delayClose();
    }
  }
);

const scrollTop = ref(document.documentElement.scrollTop);

const handleEnterComplete = () => {
  const rootElement = document.querySelector(':root');
  // @ts-ignore
  rootElement.style.setProperty('--modal-offset', '0');
};

const disableScroll = () => {
  // if (isTouchDevice()) return;

  window.onscroll = function () {
    window.scrollTo(0, scrollTop.value);
  };
};

const enableScroll = () => {
  window.onscroll = function () {};
};

watchEffect(() => {
  if (!isAboveL.value) {
    // mobile

    enableScroll();
  } else {
    // desktop
    disableScroll();
  }
});

onMounted(() => {
  scrollTop.value = document.documentElement.scrollTop;
  const rootElement = document.querySelector(':root');
  // @ts-ignore
  rootElement.style.setProperty('--modal-offset', `-${scrollTop.value}px`);

  document.documentElement.classList.add('modal-opened');
  if (!isAboveL.value) {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  }
});

onUnmounted(() => {
  document.documentElement.classList.remove('modal-opened');
  enableScroll();
});
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @include below('m') {
    position: relative;
  }
}
</style>
<style lang="scss">
html {
  &.modal-opened {
    overscroll-behavior-y: none;
    body {
      overscroll-behavior-y: none;
    }
    @include below('m') {
      #site {
        // display: none;
        position: fixed;
        top: var(--modal-offset);
      }
    }
  }
}
</style>
